import type {AnyExportDefinition} from '../types/exportTypes';
import {eventsExport} from './definitions/eventsExport';
import {healthLogExport} from './definitions/healthLogExport';
import {inventoryExport} from './definitions/inventoryExport';
import {medicationsExport} from './definitions/medicationsExport';
import {pairedDevicesExport} from './definitions/pairedDevicesExport';
import {residentEventsExport} from './definitions/residentEventsExport';
import {residentsExport} from './definitions/residentsExport';
import {roomsExport} from './definitions/roomsExport';
import {shiftsExport} from './definitions/shiftsExport';
import {tasksExport} from './definitions/tasksExport';
import {usersExport} from './definitions/usersExport';
import {workTimeExport} from './definitions/workTimeExport';

export const exportRegistry: AnyExportDefinition[] = [
  residentsExport,
  residentEventsExport,
  healthLogExport,
  medicationsExport,
  eventsExport,
  tasksExport,
  roomsExport,
  inventoryExport,
  usersExport,
  workTimeExport,
  shiftsExport,
  pairedDevicesExport,
];
